<template>
  <div id="app">
    <datav />
  </div>
</template>

<script>
import datav from "./datav/index.vue";

export default {
  name: "App",
  components: {
    datav,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less">
@import './assets/fontss/stylesheet.css';
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
